var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveInference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354.982,
    height: 299.585,
    viewBox: "0 0 354.982 299.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video_upload-amico",
    "data-name": "Video upload-amico",
    transform: "translate(-24.33 -80.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-98",
    transform: "translate(24.33 174.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67394",
    "data-name": "Path 67394",
    d: "M326.876,246.924c-69.535-40.112-181.9-40.112-250.99,0S7.2,352.167,76.766,392.31s181.9,40.151,250.99,0S396.443,287.075,326.876,246.924Z",
    transform: "translate(-24.33 -216.84)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-98",
    transform: "translate(79.951 243.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67398",
    "data-name": "Path 67398",
    d: "M255.264,256.167,57.708,371.524l-8.368-4.837L246.887,251.33Z",
    transform: "translate(-30.394 -251.33)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-98",
    transform: "translate(98.896 80.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67425",
    "data-name": "Path 67425",
    d: "M53.583,217l-.031-11L47.81,202.74l.031,10.736h0v.244L53.583,217Z",
    transform: "translate(-47.81 -79.033)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67426",
    "data-name": "Path 67426",
    d: "M53.953,347.308,53.592,219.98,47.85,216.7l.362,127.092a2.36,2.36,0,0,0,.967,2.131h0l5.655,3.461A2.359,2.359,0,0,1,53.953,347.308Z",
    transform: "translate(-47.819 -82.013)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67427",
    "data-name": "Path 67427",
    d: "M53.953,347.308,53.592,219.98,47.85,216.7l.362,127.092a2.36,2.36,0,0,0,.967,2.131h0l5.655,3.461A2.359,2.359,0,0,1,53.953,347.308Z",
    transform: "translate(-47.819 -82.013)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67428",
    "data-name": "Path 67428",
    d: "M59.761,385.23a4.08,4.08,0,0,1-.661.307A4.08,4.08,0,0,0,59.761,385.23Z",
    transform: "translate(-50.22 -117.993)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67429",
    "data-name": "Path 67429",
    d: "M58.472,385.75a.913.913,0,0,1-.142,0A.913.913,0,0,0,58.472,385.75Z",
    transform: "translate(-50.056 -118.104)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67430",
    "data-name": "Path 67430",
    d: "M57,385.6Z",
    transform: "translate(-49.772 -118.072)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67431",
    "data-name": "Path 67431",
    d: "M53.569,172.4V166.07a7.472,7.472,0,0,1,3.382-5.867L248.859,49.423a2.415,2.415,0,0,1,2.36-.244L245.556,45.7h0a2.359,2.359,0,0,0-2.446.2L51.2,156.679a7.456,7.456,0,0,0-3.382,5.875v6.292h0v.252l5.742,3.264Z",
    transform: "translate(-47.812 -45.453)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67432",
    "data-name": "Path 67432",
    d: "M53.569,172.4V166.07a7.472,7.472,0,0,1,3.382-5.867L248.859,49.423a2.415,2.415,0,0,1,2.36-.244L245.556,45.7h0a2.359,2.359,0,0,0-2.446.2L51.2,156.679a7.456,7.456,0,0,0-3.382,5.875v6.292h0v.252l5.742,3.264Z",
    transform: "translate(-47.812 -45.453)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67433",
    "data-name": "Path 67433",
    d: "M53.583,217l-.031-11L47.81,202.74l.031,10.736h0v.244L53.583,217Z",
    transform: "translate(-47.81 -79.033)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67434",
    "data-name": "Path 67434",
    d: "M53.583,217l-.031-11L47.81,202.74l.031,10.736h0v.244L53.583,217Z",
    transform: "translate(-47.81 -79.033)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67435",
    "data-name": "Path 67435",
    d: "M250.365,50.375c1.872-1.078,3.4-.2,3.406,1.951v6.339L55.13,173.353v-6.331a7.472,7.472,0,0,1,3.382-5.867Z",
    transform: "translate(-49.373 -46.405)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67436",
    "data-name": "Path 67436",
    d: "M286.509,63.762c1-.582,1.817-.118,1.825,1.038a4.011,4.011,0,0,1-1.817,3.146c-1,.574-1.817.11-1.817-1.046A3.933,3.933,0,0,1,286.509,63.762Z",
    transform: "translate(-98.384 -49.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67437",
    "data-name": "Path 67437",
    d: "M293.567,59.692c1-.582,1.817-.118,1.817,1.038a3.98,3.98,0,0,1-1.809,3.146c-1.007.574-1.817.11-1.825-1.038A3.987,3.987,0,0,1,293.567,59.692Z",
    transform: "translate(-99.889 -48.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67438",
    "data-name": "Path 67438",
    d: "M300.6,55.623c1.007-.574,1.825-.11,1.825,1.038a3.933,3.933,0,0,1-1.809,3.146c-1.007.582-1.817.118-1.825-1.038a4.027,4.027,0,0,1,1.809-3.146Z",
    transform: "translate(-101.392 -47.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67439",
    "data-name": "Path 67439",
    d: "M95.089,146.388c.747-.433,1.439-.362,1.8.2l1.8,2.776c.354.551,1.038.637,1.793.2L253.775,61.06V72.071L55.15,186.768V175.756l5.883-3.4a4.436,4.436,0,0,0,1.793-2.273l1.778-4.845a4.444,4.444,0,0,1,1.785-2.265Z",
    transform: "translate(-49.377 -48.785)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67440",
    "data-name": "Path 67440",
    d: "M253.806,75l.362,127.328a7.5,7.5,0,0,1-3.39,5.867L58.917,319c-1.88,1.085-3.406.212-3.406-1.943L55.15,189.728Z",
    transform: "translate(-49.377 -51.761)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60566",
    "data-name": "Group 60566",
    transform: "translate(5.773 23.239)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67441",
    "data-name": "Path 67441",
    d: "M253.806,75l.362,127.328a7.5,7.5,0,0,1-3.39,5.867L58.917,319c-1.88,1.085-3.406.212-3.406-1.943L55.15,189.728Z",
    transform: "translate(-55.15 -75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67442",
    "data-name": "Path 67442",
    d: "M251.451,69.568c1.329-.787,2.415-.157,2.415,1.376a5.3,5.3,0,0,1-2.4,4.169L83.342,172.2c-1.329.787-2.415.157-2.422-1.376a5.309,5.309,0,0,1,2.407-4.168Z",
    transform: "translate(-54.879 -50.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67443",
    "data-name": "Path 67443",
    d: "M58.641,208.12a.212.212,0,0,1,.244,0c.134.086.118.338,0,.566l-1.078,1.691,2.784-1.573a.213.213,0,0,1,.346.189.786.786,0,0,1-.346.59l-2.784,1.573,1.07.5c.134.071.149.315,0,.543a.692.692,0,0,1-.252.267.26.26,0,0,1-.236.039l-1.707-.786-.063-.071h0v-.315h0l.055-.142,1.707-2.784A.637.637,0,0,1,58.641,208.12Z",
    transform: "translate(-49.691 -80.173)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67444",
    "data-name": "Path 67444",
    d: "M66.217,203.7a.267.267,0,0,1,.236,0l1.707.786.071.079h0v.346l-.063.134-1.7,2.816a.676.676,0,0,1-.236.236.212.212,0,0,1-.244,0c-.126-.079-.126-.33,0-.558l1.054-1.73-2.784,1.573a.21.21,0,0,1-.338-.2.787.787,0,0,1,.338-.582l2.784-1.573-1.062-.511c-.142-.063-.149-.307,0-.543A.787.787,0,0,1,66.217,203.7Z",
    transform: "translate(-51.249 -79.232)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67445",
    "data-name": "Path 67445",
    d: "M73.616,199.3a1.447,1.447,0,0,1,1.148-.212l.26-.338a.621.621,0,0,1,.181-.173.315.315,0,0,1,.181-.039c.118,0,.173.142.157.307l-.142,1.046a.787.787,0,0,1-.149.354.707.707,0,0,1-.181.165l-.087.039-.787.228a.189.189,0,0,1-.252-.173.637.637,0,0,1,.149-.472l.079-.11a1.085,1.085,0,0,0-.519.157,2.729,2.729,0,0,0-1.219,2.116c0,.787.558,1.085,1.227.7a2.706,2.706,0,0,0,1.078-1.345.724.724,0,0,1,.291-.378.33.33,0,0,1,.165-.047c.165,0,.228.22.134.456a4.1,4.1,0,0,1-1.667,2.092c-1.046.606-1.9.118-1.9-1.085A4.192,4.192,0,0,1,73.616,199.3Z",
    transform: "translate(-52.923 -78.136)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60567",
    "data-name": "Group 60567",
    transform: "translate(6.929 127.908)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67446",
    "data-name": "Path 67446",
    d: "M58.641,208.12a.212.212,0,0,1,.244,0c.134.086.118.338,0,.566l-1.078,1.691,2.784-1.573a.213.213,0,0,1,.346.189.786.786,0,0,1-.346.59l-2.784,1.573,1.07.5c.134.071.149.315,0,.543a.692.692,0,0,1-.252.267.26.26,0,0,1-.236.039l-1.707-.786-.063-.071h0v-.315h0l.055-.142,1.707-2.784A.637.637,0,0,1,58.641,208.12Z",
    transform: "translate(-56.62 -208.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60568",
    "data-name": "Group 60568",
    transform: "translate(12.671 124.443)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67447",
    "data-name": "Path 67447",
    d: "M66.217,203.7a.267.267,0,0,1,.236,0l1.707.786.071.079h0v.346l-.063.134-1.7,2.816a.676.676,0,0,1-.236.236.212.212,0,0,1-.244,0c-.126-.079-.126-.33,0-.558l1.054-1.73-2.784,1.573a.21.21,0,0,1-.338-.2.787.787,0,0,1,.338-.582l2.784-1.573-1.062-.511c-.142-.063-.149-.307,0-.543A.787.787,0,0,1,66.217,203.7Z",
    transform: "translate(-63.92 -203.675)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60569",
    "data-name": "Group 60569",
    transform: "translate(18.837 120.403)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67448",
    "data-name": "Path 67448",
    d: "M73.616,199.3a1.447,1.447,0,0,1,1.148-.212l.26-.338a.621.621,0,0,1,.181-.173.315.315,0,0,1,.181-.039c.118,0,.173.142.157.307l-.142,1.046a.787.787,0,0,1-.149.354.707.707,0,0,1-.181.165l-.087.039-.787.228a.189.189,0,0,1-.252-.173.637.637,0,0,1,.149-.472l.079-.11a1.085,1.085,0,0,0-.519.157,2.729,2.729,0,0,0-1.219,2.116c0,.787.558,1.085,1.227.7a2.706,2.706,0,0,0,1.078-1.345.724.724,0,0,1,.291-.378.33.33,0,0,1,.165-.047c.165,0,.228.22.134.456a4.1,4.1,0,0,1-1.667,2.092c-1.046.606-1.9.118-1.9-1.085A4.192,4.192,0,0,1,73.616,199.3Z",
    transform: "translate(-71.76 -198.539)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60570",
    "data-name": "Group 60570",
    transform: "translate(46.792 75.129)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67449",
    "data-name": "Path 67449",
    d: "M198.728,169.261l.2,72.285a13.543,13.543,0,0,1-6.744,11.737L78.329,319.374a4.514,4.514,0,0,1-6.781-3.891l-.2-72.285a13.543,13.543,0,0,1,6.744-11.737l113.853-66.046a4.514,4.514,0,0,1,6.781,3.846Z",
    transform: "translate(-71.35 -164.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60573",
    "data-name": "Group 60573",
    transform: "translate(19.513 132.366)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67453",
    "data-name": "Path 67453",
    d: "M86.848,214.237v7.535a1.455,1.455,0,0,1-.724,1.258l-12.773,7.322a.488.488,0,0,1-.731-.417v-7.527a1.455,1.455,0,0,1,.724-1.266l12.773-7.322a.48.48,0,0,1,.731.417Z",
    transform: "translate(-72.62 -213.749)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67454",
    "data-name": "Path 67454",
    d: "M79.85,222.06l3.98.338-3.964,4.924Z",
    transform: "translate(-54.65 -83.157)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60574",
    "data-name": "Group 60574",
    transform: "translate(25.2 138.903)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67455",
    "data-name": "Path 67455",
    d: "M79.85,222.06l3.98.338-3.964,4.924Z",
    transform: "translate(-79.85 -222.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60575",
    "data-name": "Group 60575",
    transform: "translate(95.097 41.1)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67456",
    "data-name": "Path 67456",
    d: "M180.266,162.93l.016,4.066-11.554,6.67-.008-4.066Z",
    transform: "translate(-168.72 -111.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67457",
    "data-name": "Path 67457",
    d: "M207.39,146.66l.008,4.074L192,159.622l-.008-4.066Z",
    transform: "translate(-173.688 -108.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67458",
    "data-name": "Path 67458",
    d: "M265.054,113.97l.008,4.074-11.554,6.67-.008-4.066Z",
    transform: "translate(-186.82 -101.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67459",
    "data-name": "Path 67459",
    d: "M292.178,97.71l.008,4.066-15.4,8.9-.016-4.066Z",
    transform: "translate(-191.788 -97.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67460",
    "data-name": "Path 67460",
    d: "M238.431,128.28l.016,4.066-18.389,10.61-.008-4.066Z",
    transform: "translate(-179.679 -104.236)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67482",
    "data-name": "Path 67482",
    d: "M107.785,203.23l.008,2.643-14.385,8.211-.008-2.635Z",
    transform: "translate(-57.543 -79.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67483",
    "data-name": "Path 67483",
    d: "M102.468,212.11l.008,2.643L93.408,219.9l-.008-2.643Z",
    transform: "translate(-57.543 -81.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67484",
    "data-name": "Path 67484",
    d: "M173.325,199.572a2.483,2.483,0,0,0-3.738-2.149l-62.876,36.467A7.485,7.485,0,0,0,103,240.346v7.548l70.343-40.81Z",
    transform: "translate(-27.631 -92.81)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67485",
    "data-name": "Path 67485",
    d: "M103,249.01l.1,44.115a2.492,2.492,0,0,0,3.738,2.149L169.713,258.8a7.458,7.458,0,0,0,3.72-6.492l-.09-44.106Z",
    transform: "translate(-27.631 -93.89)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60582",
    "data-name": "Group 60582",
    transform: "translate(76.298 104.28)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67486",
    "data-name": "Path 67486",
    d: "M109.492,235.826l-5.462,15.051,4.867-2.817L114.359,233Z",
    transform: "translate(-104.03 -200.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67487",
    "data-name": "Path 67487",
    d: "M122.332,228.377l-5.462,15.051,4.867-2.817L127.2,225.56Z",
    transform: "translate(-105.277 -199.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67488",
    "data-name": "Path 67488",
    d: "M135.172,220.927l-5.462,15.06,4.867-2.826,5.462-15.051Z",
    transform: "translate(-106.524 -199.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67489",
    "data-name": "Path 67489",
    d: "M148,213.486l-5.462,15.051,4.866-2.826,5.462-15.051Z",
    transform: "translate(-107.77 -198.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67490",
    "data-name": "Path 67490",
    d: "M160.842,206.036l-5.462,15.051,4.866-2.817,5.462-15.06Z",
    transform: "translate(-109.017 -197.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67491",
    "data-name": "Path 67491",
    d: "M175.922,197.424l-2.239,1.291-5.462,15.06,4.867-2.826,4.966-13.688a2.447,2.447,0,0,0-2.131.163Z",
    transform: "translate(-110.264 -197.091)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60588",
    "data-name": "Group 60588",
    transform: "translate(107.712 151.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67455-2",
    "data-name": "Path 67455",
    d: "M79.85,222.06l14.322,1.217L79.907,241Z",
    transform: "translate(-79.85 -222.06)",
    fill: "#c6cbce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-98",
    transform: "translate(128.135 99.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67509",
    "data-name": "Path 67509",
    d: "M357.384,75.442c-5.364-3.1-9.9-1.573-11.341,3.233a15.982,15.982,0,0,0-5.8-6.457c-4.2-2.422-7.629-.472-7.645,4.357v2.218l-5.647-3.256c-2.949-1.7-5.34-.33-5.356,3.052a11.727,11.727,0,0,0,5.317,9.21L374.75,115.42c2.942,1.7,5.348.338,5.356-3.052a11.727,11.727,0,0,0-5.325-9.21L369.1,99.895V95.813C369.166,88.341,363.9,79.2,357.384,75.442Z",
    transform: "translate(-135.227 -71.177)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67510",
    "data-name": "Path 67510",
    d: "M353.662,85.09l7.149,13.08-4.318-2.493-.031,9.666-5.71-3.3.024-9.666-4.326-2.5Z",
    transform: "translate(-140.534 -74.147)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67511",
    "data-name": "Path 67511",
    d: "M357.666,111.665l-.008,3.7-5.718-3.3.008-3.7Z",
    transform: "translate(-141.706 -79.117)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67512",
    "data-name": "Path 67512",
    d: "M357.666,118.263l-.008,1.848-5.718-3.3.008-1.848Z",
    transform: "translate(-141.706 -80.524)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67513",
    "data-name": "Path 67513",
    d: "M357.666,122.185l-.008,1.117-5.718-3.3.008-1.117Z",
    transform: "translate(-141.706 -81.363)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60584",
    "data-name": "Group 60584",
    transform: "translate(205.916 10.943)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67514",
    "data-name": "Path 67514",
    d: "M353.662,85.09l7.149,13.08-4.318-2.493-.031,9.666-5.71-3.3.024-9.666-4.326-2.5Z",
    transform: "translate(-346.45 -85.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67515",
    "data-name": "Path 67515",
    d: "M357.666,111.665l-.008,3.7-5.718-3.3.008-3.7Z",
    transform: "translate(-347.622 -90.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67516",
    "data-name": "Path 67516",
    d: "M357.666,118.263l-.008,1.848-5.718-3.3.008-1.848Z",
    transform: "translate(-347.622 -91.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67517",
    "data-name": "Path 67517",
    d: "M357.666,122.185l-.008,1.117-5.718-3.3.008-1.117Z",
    transform: "translate(-347.622 -92.306)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67518",
    "data-name": "Path 67518",
    d: "M108.2,77.449c5.561-3.217,10.225-1.644,11.8,3.358a16.517,16.517,0,0,1,6.009-6.7c4.365-2.517,7.912-.488,7.928,4.522v2.3l5.852-3.382c3.06-1.762,5.506-.338,5.553,3.146a12.152,12.152,0,0,1-5.506,9.548L90.193,118.9c-3.06,1.77-5.506.354-5.553-3.146a12.144,12.144,0,0,1,5.506-9.556l5.859-3.382V98.583C95.974,90.8,101.44,81.35,108.2,77.449Z",
    transform: "translate(-84.64 -71.572)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60587",
    "data-name": "Group 60587",
    transform: "translate(25.216 19.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67519",
    "data-name": "Path 67519",
    d: "M123.818,129.861l7.063-12.914-4.263,2.462-.031-9.548-5.639,3.256.024,9.548-4.271,2.47Z",
    transform: "translate(-116.7 -99.25)",
    fill: "#192e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67520",
    "data-name": "Path 67520",
    d: "M127.775,107.169l-.008-3.649-5.647,3.256.016,3.657Z",
    transform: "translate(-117.856 -97.896)",
    fill: "#192e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67521",
    "data-name": "Path 67521",
    d: "M127.775,101.155l-.008-1.825-5.647,3.264.016,1.825Z",
    transform: "translate(-117.856 -97.002)",
    fill: "#192e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67522",
    "data-name": "Path 67522",
    d: "M127.775,97.479l-.008-1.109-5.647,3.264.016,1.1Z",
    transform: "translate(-117.856 -96.37)",
    fill: "#192e3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveInference);
export default __webpack_public_path__ + "static/media/liveInference.5978e613cc7a57994080b6cac89c3112.svg";
export { ForwardRef as ReactComponent };